import React from 'react';
import styles from './interventionProgress.module.scss';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import moment from 'moment';

export default class InterventionProgress extends React.Component {
	constructor (props) {
		super(props);
		
		this.state = {
			counter: 0,
			timeRemaining: props.timeRemaining,
			toDate: moment(new Date()).add(props.timeRemaining, 'ms').toDate()
		};
		
		this._interval = null;
		
		this.tick = this.tick.bind(this);
		this.clearIntervalAndFinishIntervention = this.clearIntervalAndFinishIntervention.bind(this);
	}
	
	componentDidUpdate (prevProps) {
		if (prevProps.status !== this.props.status && this.props.status === 'PAUSED' && this.props.interventionType.toUpperCase() !== 'ASSESSMENT') {
			this.props.updateTimeElapsed(new Date(), this.state.toDate);
			if (this._interval) {
				clearInterval(this._interval);
			}
		}
		
		if (prevProps.status !== this.props.status && this.props.status === 'IN_PROGRESS' && this.props.timeElapsed > 0 && prevProps.status === 'PAUSED') {
			// console.log(this.props.timeRemaining);
			this.setState({
				timeRemaining: this.props.timeRemaining,
				toDate: moment().add(this.props.timeRemaining, 'ms').toDate()
			});
			this._interval = setInterval(this.tick, 10);
			setTimeout(() => {
				this.clearIntervalAndFinishIntervention();
			}, this.props.timeRemaining);
		}
	}
	
	componentDidMount () {
		if (this.state.counter > 0) {
			this.setState({
				counter: 0,
			}, () => {
				if (this._interval) {
					clearInterval(this._interval);
				}
			});
		}
		this._interval = setInterval(this.tick, 10);
		setTimeout(() => {
			this.clearIntervalAndFinishIntervention();
		}, this.props.timeRemaining);
	}
	
	componentWillUnmount () {
		this.clearIntervalAndFinishIntervention();
	}
	
	tick () {
		const localDateObj = new Date(this.state.toDate);
		this.setState({
			counter: localDateObj - new Date()
		});
	}

	
	clearIntervalAndFinishIntervention () {
		clearInterval(this._interval);
		if (this.props.interventionType.toUpperCase() !== 'ASSESSMENT' && this.props.status === 'IN_PROGRESS') {
			this.setState({
				counter: 0,
			}, () => {
				this.props.finishIntervention();
			});
		}
	}
	
	millisToMinutesAndSeconds (millis) {
		var minutes = Math.floor(millis / 60000);
		var seconds = ((millis % 60000) / 1000).toFixed(0);
		return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
	}
	
	render () {
		let progress = 1;
		if (this.state.counter !== -1) {
			progress = (this.props.timeRemaining - this.state.counter) / this.props.timeAllowed;
		}
		return (
			<>
				{/*<Progress.Pie*/}
				{/*	size={60}*/}
				{/*	animated={true}*/}
				{/*	borderWidth={8}*/}
				{/*	color="#DCDCDC"*/}
				{/*	unfilledColor="#F7F7F7"*/}
				{/*	borderColor="#DCDCDC"*/}
				{/*	progress={progress}*/}
				{/*/>*/}
				<CountdownCircleTimer
					isPlaying={this.props.status === 'IN_PROGRESS'}
					duration={this.props.timeAllowed / 1000}
					colors={[
						['#004777', 0.33],
						['#F7B801', 0.33],
						['#A30000', 0.33],
					]}
					size={60}
					strokeWidth={8}
				/>
				<div className={styles.timeRemaining}>
					{this.millisToMinutesAndSeconds(this.state.counter)}
				</div>
			</>
		)
	}
}
